import { useEffect } from "react";

/**
 * Custom hook to set page title
 * @param {string} title - The page title (e.g., "Dashboard")
 * @param {boolean} appendSuffix - Whether to append " | Theo CRM" (default: true)
 */
export function usePageTitle(title, appendSuffix = true) {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = appendSuffix ? `${title} | Theo CRM` : title;

    // Cleanup: restore previous title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title, appendSuffix]);
}
